import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
import theyEye from "assets/images/ct/they-know-eye.png";
import twoDice from "assets/images/ct/two-dice.png";
import disLine from "assets/images/ct/dis-line.png";
import diceImg from "assets/images/ct/dice.png";
import tech from "assets/images/ct/tech.png";
import aliens from "assets/images/ct/aliens.png";
import schemes from "assets/images/ct/schemes.png";
import mythos from "assets/images/ct/mythos.png";
import random from "assets/images/ct/random.png";

const CoverUpScreen = ({ CoverUpData, currentPlayer, roomId, screens ,buzzer_sound,default_audio_effect}) => {
  const [counter, setCounter] = useState(10);

  const all_info_1 = _.get(
    screens,
    "3_dicerollresult.coverup.all_info_1",
    "You have been involved in a cover up by the enemies of truth."
  );
  const all_info_2 = _.get(
    screens,
    "3_dicerollresult.coverup.all_info_2",

    "Lose all of your conspiracy cards"
  );

  const button = _.get(
    screens,
    "3_dicerollresult.coverup.button",

    "END TURN"
  );

  const coverup_title = _.get(
    screens,
    "3_dicerollresult.coverup.coverup_title",

    "COVER UP"
  );

  const none_info_1 = _.get(
    screens,
    "3_dicerollresult.coverup.none_info_1",
    "You have been involved in a cover up by the enemies of truth."
  );

  const none_info_2 = _.get(
    screens,
    "3_dicerollresult.coverup.none_info_2",

    "Keep you cards, but lose your turn"
  );

  const one_info = _.get(
    screens,
    "3_dicerollresult.coverup.one_info",
    "You have been involved in a cover up by the enemies of truth."
  );

  const instructions = CoverUpData?.instructions?.split(/\s+/) || [];
  let loseOneTypeOfCard;
  let loseAllCards;
  switch (instructions[3]) {
    case null:
      loseAllCards = false;
      loseOneTypeOfCard = false;
      break;
    case "CONSPIRACY":
      loseAllCards = true;
      loseOneTypeOfCard = false;
      break;
    default:
      loseAllCards = false;
      loseOneTypeOfCard = true;
      break;
  }
  let cardImg =
    instructions[3] === "SCHEMES"
      ? schemes
      : instructions[3] === "MYTHOS"
      ? mythos
      : instructions[3] === "RANDOM"
      ? random
      : instructions[3] === "TECH"
      ? tech
      : aliens;

  useEffect(() => {
    let timer;
    timer =
      counter > 0 && setInterval(() => setCounter((prev) => prev - 1), 1000);
    counter === 0 && onUpdateStatus("update");
    return () => clearInterval(timer);
  }, [counter]);

  const buttonPressAction = () => {
    const data = {
      action: "special-action",
      roomId,
      playerId: currentPlayer?.player_id,
      specialAction: "End Turn"
    };
    Socket.sendMessage(data);
  };

  const onUpdateStatus = useCallback(
    _.debounce((type) => buttonPressAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [roomId]
  );

  useEffect(() => {
    if (  !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, default_audio_effect]);
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="coverup-main"
    >
      <div className="coverup">
        <div className="dis-top">
          <motion.div variants={fadeVariants} className="dis-text">
            <img src={theyEye} className="img-fluid" alt="" />
            <div className="text-right">
              <img src={twoDice} className="img-fluid" alt="" />
              <h4>{coverup_title}</h4>
              <img src={disLine} className="img-fluid disLine" alt="" />
            </div>
          </motion.div>
          <motion.p variants={fadeVariants} className="desc">
           {all_info_1}
          </motion.p>
          {loseOneTypeOfCard ? (
            <>
              <motion.p variants={fadeVariants} className="desc text-left">
                Lose all of your{instructions[3]} cards
              </motion.p>
              <motion.div
                variants={staticBounceVariants}
                className="text-center"
              >
                <img src={cardImg} className="img-fluid mb-3" alt="" />
              </motion.div>
            </>
          ) : loseAllCards ? (
            <>
              <motion.p variants={fadeVariants} className="desc text-left">
              {all_info_2}
              </motion.p>
              <motion.div variants={staticBounceVariants} className="cards">
                <img src={tech} className="img-fluid card1" alt="" />
                <img src={aliens} className="img-fluid card2" alt="" />
                <img src={schemes} className="img-fluid card3" alt="" />
                <img src={mythos} className="img-fluid card4" alt="" />
                <img src={random} className="img-fluid card5" alt="" />
              </motion.div>
            </>
          ) : (
            <>
              <motion.p variants={fadeVariants} className="desc text-left">
              {none_info_2}
              </motion.p>
            </>
          )}
        </div>

        <motion.div variants={staticBounceVariants} className="text-center">
          <button className="ct-btn-green end-btn" onClick={buttonPressAction}>
           {button} ({counter})
          </button>
        </motion.div>

        {/*   <div className="text-center">
          <p className="desc">You found a card!</p>
          <img src={tech} className="img-fluid mb-3" alt="" />
          <button className="ct-btn-green end-btn">end turn (10)</button>
        </div> */}
      </div>
    </motion.div>
  );
};

export default CoverUpScreen;
